
import React from 'react';
import { FormField } from '@/components/ui/form';
import SimpleCaptcha from '@/components/auth/SimpleCaptcha';
import { UseFormReturn } from 'react-hook-form';
import { FormControl, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';

interface CaptchaFieldProps {
  form: UseFormReturn<any>;
  onGenerate: (text: string) => void;
}

const CaptchaField = ({ form, onGenerate }: CaptchaFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="captcha"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Security Check</FormLabel>
          <div className="space-y-2">
            <SimpleCaptcha onGenerate={onGenerate} />
            <FormControl>
              <Input 
                {...field} 
                placeholder="Enter the text shown above"
                autoComplete="off" 
              />
            </FormControl>
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default CaptchaField;
